import { combineReducers } from '@ynap/reducer-utils';

import notification from './notification';

const reducers = combineReducers({ notification });

export default reducers;
